// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__RDC2G","footer":"ModalFilter_footer__3tdzv"};